import MainTabs from "./views/mainTabs";
import Login from "./login";
import SecondsTabs from "./views/secondsTabs";
import EmailLogin from "./views/emailLogin";
import EmailRegistration from "./views/emailRegistration";
import PhoneRegistration from "./views/phoneRegistration";
import PhoneLogin from "./views/phoneLogin";
import {Api} from "../api/api";
import Code from "./views/code";
import Error from './views/error';

export const login = () => {
  const loginContainer = document.querySelector(`.js-login`);

  if (loginContainer) {
    const api = new Api();

    const mainTabsView = new MainTabs(loginContainer);
    const secondsTabsView = new SecondsTabs(loginContainer);
    const errorView = new Error(loginContainer, `.js-login-error`);
    const emailLoginView = new EmailLogin(loginContainer, `.js-login-email`, api, errorView);
    const emailRegistrationView = new EmailRegistration(loginContainer, `.js-registration-email`, api, errorView);
    const phoneRegistrationView = new PhoneRegistration(loginContainer, `.js-registration-phone`, api, errorView);
    const phoneLoginView = new PhoneLogin(loginContainer, `.js-login-phone`, api, errorView);
    const codeView = new Code(loginContainer, `.js-login-code`, api, errorView);

    const login = new Login(
      loginContainer,
      mainTabsView,
      secondsTabsView,
      emailLoginView,
      emailRegistrationView,
      phoneRegistrationView,
      phoneLoginView,
      codeView,
      errorView
    );
    login.init();
  }
};
